import { render, staticRenderFns } from "./AdditiveIndex.vue?vue&type=template&id=43562aa0&scoped=true"
import script from "./AdditiveIndex.vue?vue&type=script&lang=js"
export * from "./AdditiveIndex.vue?vue&type=script&lang=js"
import style0 from "./AdditiveIndex.vue?vue&type=style&index=0&id=43562aa0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43562aa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43562aa0')) {
      api.createRecord('43562aa0', component.options)
    } else {
      api.reload('43562aa0', component.options)
    }
    module.hot.accept("./AdditiveIndex.vue?vue&type=template&id=43562aa0&scoped=true", function () {
      api.rerender('43562aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/additive/AdditiveIndex.vue"
export default component.exports